import { type Static, Type } from '@sinclair/typebox';
import { MongooseObjectIdOrStringSchema, MongooseRefSchema } from './common.dto.js';
import { TierDTOSchema } from './tier.dto.js';

export const ITEM_DESCRIPTION_MAX_LENGTH = 20_000;
export const ITEM_TITLE_MAX_LENGTH = 200;

export const ItemDTOSchema = Type.Object({
  _id: MongooseObjectIdOrStringSchema,
  author: Type.Optional(Type.String()),
  description: Type.Optional(
    Type.Transform(Type.String())
      .Decode(v => v)
      .Encode(v => v.slice(0, ITEM_DESCRIPTION_MAX_LENGTH)),
  ),
  inCreation: Type.Optional(Type.Boolean()),
  image30: Type.String(),
  image60: Type.String(),
  image100: Type.String(),
  image600: Type.String(),
  isHostedByFuuze: Type.Optional(Type.Boolean()),
  pubDate: Type.Optional(Type.Any()),
  // pubDate: Type.Transform(Type.Union([Type.Date(), Type.String()]))
  //   .Decode((v) => v)
  //   .Encode((v) => (v as Date).toISOString()),
  slug: Type.String(),
  title: Type.Transform(Type.String())
    .Decode(v => v)
    .Encode(v => v.slice(0, ITEM_TITLE_MAX_LENGTH)),
  visibility: Type.Union([Type.Literal('public'), Type.Literal('hidden'), MongooseRefSchema(TierDTOSchema)]),
});

export type ItemDTO = Static<typeof ItemDTOSchema>;
